export const APPLICATION_MODE_NEW = "new";
export const APPLICATION_MODE_RENEW = "renewal";

export const AUTHORITY_BUSINESS_LICENCE_ADMIN = "ADMIN";
export const AUTHORITY_BUSINESS_USER = "BUSINESS_USER";

export const VIEW_MODE_REGULAR = "regular";
export const VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT = "editReviewBeforeSubmit";
export const VIEW_MODE_RENEWAL_PREVIEW = "renewalPreview";
export const VIEW_MODE_RENEWAL_EDIT = "renewalEdit";

export const CanadaProvinceList = {
  unknown: "Select province",
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland And Labrador",
  NS: "Nova Scotia",
  NT: "Northwest Territories",
  NU: "Nunavut",
  ON: "Ontario",
  PEI: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YK: "Yukon",
};

export const COLLECTOR_AGENCY_FEES_CAD = 464.75;
export const COLLECTOR_AGENCY_ADDITIONAL_BRANCH_FEES_CAD = 165.7;
export const COLLECTOR_FEES_CAD = 66.0;

export const totalFileSizeAllowedInMB = 50;
export const individualFileSizeAllowedInMB = 15;

export const COMPANY_TYPES = {
  "corporated": "Corporation, incorporated or continued under the laws of any jurisdiction of Canada",
  "partnership": "Partnership",
  "solo": "Sole Proprietor"
}

export const MORTGAGE_PROPERTY_KEYS = {
  IS_CO_QUALIFICATIONS_ACCEPTED: "isCOQualificationsAccepted",
  BROKER_DUTIES_CONFIRMATION: "principalBrokerDutiesConfirmation"
}